import { createContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { Navigate, useParams } from 'react-router'
import { AppRoutes } from '../../app-routes'
import { DialogContextTypes } from '../../enums'
import {
  clearAxiosBoatHeader,
  clearAxiosClientHeader,
  setAxiosBoatHeader,
  setAxiosClientHeader,
} from '../../helpers/AuthorizationHelpers'
import { useDialogCtx } from '../../hooks/context-hooks'
import { getBoat } from '../../http'
import { clearAxiosFeatureValueHeader, setAxiosFeatureValueHeader } from '../../Http/featureHttp'
import { Queries } from '../../queries'
import { IBoat } from '../../types/data-types'
import { CenteredSpinner } from '../Common/Spinner'

export const BoatLayoutContext = createContext<{ boat: IBoat; permission: number; featureValue: bigint }>(undefined)

export const BoatLayoutContextProvider = ({ children }) => {
  const { id: boatId } = useParams<any>()
  const { data: boat, isLoading, isError, error } = useQuery([Queries.BOAT, boatId], () =>
    getBoat(Queries.BOAT, boatId),
  )

  const [providerValue, setProviderValue] = useState(null)
  const { getDialogs } = useDialogCtx()

  useEffect(() => {
    return () => {
      clearAxiosClientHeader()
      clearAxiosBoatHeader()
      clearAxiosFeatureValueHeader()
    }
  }, [])

  useEffect(() => {
    if (!!boat && boat != providerValue?.boat) {
      setProviderValue({ boat, permission: boat.permissionValue, featureValue: BigInt(boat?.featureValue) })
      setAxiosClientHeader(boat.clientId)
      setAxiosBoatHeader(boat.boatId)
      setAxiosFeatureValueHeader(boat?.encryptedFeatureValue)
    }
  }, [boat])
  if (isError) return <Navigate to={AppRoutes.NOT_FOUND} />

  return (
    <BoatLayoutContext.Provider value={providerValue}>
      {Object.values(getDialogs(DialogContextTypes.boat) ?? {})}
      {!providerValue ? <CenteredSpinner /> : children}
    </BoatLayoutContext.Provider>
  )
}
